import React, { Component } from 'react';

import Add from './add';
import Edit from './edit';


import Loading from '../../loading';
import Server from '../../../functions/server'
import $ from "jquery";


class Branch extends Component {

  state = {
    data: null,
    load: false,
    message: '',
  }

  componentDidMount() {
    this.getBranch();
  }

  componentDidUpdate(props) {
    if (props.partno != this.props.partno) {
      this.getBranch();
    }
  }

  getBranch() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Spares Branch!!!'
    });
    let data1 = {'partno': this.props.partno};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/getbranch.php',
      success: function(data)
      {
        data = JSON.parse(data);
        console.log(data);
        if (data.length >= 1) {
          context.setState({
            load: false,
            data: data
          });
        }
        else {
          context.setState({
            load: false,
          });
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  render() {
    let { load, message } = this.state;
    let loading, edit;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    if (this.state.data) {
      edit = this.state.data.map((z) => {
        return (
          <Edit
            partno={this.props.partno}
            data={z}/>
        )
      })
    }
    return (
      <div>
        { this.state.data ? (<div>{edit}</div>) : (<div><Add partno={this.props.partno} /></div>) }
        {loading}
      </div>
    );
  }
}

export default Branch;
